import { useState } from "react";
import "./ValPlans.css";

const ValPlans = ({ onBack }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const plans = [
    {
      id: 1,
      title: "Luxury Spa Retreat",
      shortDesc: "A rejuvenating spa experience for you",
      image: "https://images.unsplash.com/photo-1544161515-81205f8abecc?w=800",
      fullDescription: "I've booked you a luxurious spa experience @ Anasa Spa & Wellness Center where you can relax and be pampered with professional treatments. It's all about you feeling special and rejuvenated. We'll enjoy a peaceful afternoon with massages, pedicure, and all the pampering you deserve. Your booked ticket and receipt will have all the details.",
      details: [
        "Professional spa treatment & pedicure just for you",
        "Relaxing massage and wellness experience",
        "Complimentary refreshments",
        "Your booked ticket with all details"
      ],
      actionText: "View Booking Details",
      actionLink: null // Will be updated when user uploads the booking
    },
    {
      id: 2,
      title: "Labadi Beach Sunset & Sunrise",
      shortDesc: "A romantic night at Labadi Beach to watch the sunrise",
      image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800",
      fullDescription: "We'll spend a magical evening at Labadi Beach. We'll enjoy the sunset with your favorite foods, good music, and each other. After a romantic night under the stars, we'll wake up early to catch the breathtaking sunrise over the Ocean. It's an unforgettable experience celebrating our love by the sea.",
      details: [
        "Night at Labadi Beach with sunset views",
        "Music and quality time together",
        "Wake up for the stunning sunrise over the ocean",
        "Refreshments and beach activities"
      ],
      actionText: "Save Location"
    }
  ];

  return (
    <section className="val-plans-section">
      <div className="plans-container">
        <div className="plans-header">
          <button className="btn-secondary header-back-btn" onClick={onBack}>
            ← Back
          </button>
          <div className="plans-header-content">
            <h2 className="section-title">Valentine's Day Plans</h2>
            <p className="plans-subtitle">Two special experiences to celebrate our love</p>
          </div>
        </div>

        {!selectedPlan ? (
          <div className="plans-grid">
            {plans.map((plan) => (
              <div
                key={plan.id}
                className="plan-card"
                onClick={() => setSelectedPlan(plan)}
              >
                <div className="plan-image-wrapper">
                  <img 
                    src={plan.image} 
                    alt={plan.title}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="photo-placeholder" style={{ display: 'none' }}>
                    <span>💕</span>
                  </div>
                  <div className="plan-overlay">
                    <h3 className="plan-title">{plan.title}</h3>
                    <p className="plan-short-desc">{plan.shortDesc}</p>
                    <button className="plan-btn">View Details</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="plan-detail">
            <button className="back-to-plans" onClick={() => setSelectedPlan(null)}>
              ← Back to Options
            </button>
            <div className="detail-content">
              <div className="detail-image">
                <img 
                  src={selectedPlan.image} 
                  alt={selectedPlan.title}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="photo-placeholder" style={{ display: 'none' }}>
                  <span>💕</span>
                </div>
              </div>
              <div className="detail-text">
                <h3 className="detail-title">{selectedPlan.title}</h3>
                <p className="detail-description">{selectedPlan.fullDescription}</p>
                <div className="detail-list">
                  <h4>What's Included:</h4>
                  <ul>
                    {selectedPlan.details.map((detail, index) => (
                      <li key={index}>{detail}</li>
                    ))}
                  </ul>
                </div>
                
                {selectedPlan.id === 1 && (
                  <div className="booking-section">
                    <p className="booking-info">Your spa booking is confirmed! Your ticket and receipt will be available here soon.</p>
                    <button 
                      className="btn-primary action-btn"
                      disabled
                      title="Booking details coming soon"
                    >
                      📋 View Booking Details (Coming Soon)
                    </button>
                  </div>
                )}
                
                {selectedPlan.id === 2 && (
                  <div className="location-section">
                    <p className="location-info">📍 Labadi Beach, Accra, Ghana</p>
                    <p className="location-desc">One of the most beautiful beaches in Ghana with pristine golden sands and stunning ocean views.</p>
                    <a 
                      href="https://maps.app.goo.gl/61LrZeejZsDmd4M46?g_st=com.google.maps.preview.copy" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn-primary action-btn"
                    >
                      📍 Open in Maps
                    </a>
                  </div>
                )}
                
                <div className="detail-message">
                  <p>I can't wait to spend this special Valentine's Day with you, celebrating our love. 💕</p>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="nav-buttons"></div>
      </div>
    </section>
  );
};

export default ValPlans;
